import formatTableJson from '@/config/tableComponentParams.js'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'account',
    label: i18n.t('Common.account'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'admin',
    label: i18n.t('Common.name'),
    width: '200px',
    showOverflowTooltip: true
  },
  {
    filed: 'ip',
    label: i18n.t('Common.ip'),
    width: '100px',
    showOverflowTooltip: true
  },
  {
    filed: 'uri',
    label: 'URL',
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'moduleName',
    label: i18n.t('System.logModuleName'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'operation',
    label: i18n.t('System.logOperation'),
    width: '200px',
    showOverflowTooltip: true
  },
  {
    filed: 'createTime',
    label: i18n.t('System.logCreateTime'),
    type: 'time',
    width: '180px',
    showOverflowTooltip: true
  }
])
